import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DayTimeline } from './DayTimeline';
import { Badge } from '@/components/ui/badge';
import { MapPin, Calendar } from 'lucide-react';

export const ResultPanel = ({ result }) => {
  if (!result) return null;

  return (
    <div className="space-y-6 result-panel">
      <Card className="border-0 shadow-card rounded-card bg-white">
        <CardHeader>
          <div className="flex items-start justify-between">
            <div>
              <CardTitle className="text-2xl text-text-primary mb-2">
                {result.destination || '旅行行程'} {result.days}天深度游
              </CardTitle>
              <p className="text-text-secondary text-sm leading-relaxed">
                {result.totalBudget ? `预计总预算：${result.totalBudget}` : 'AI生成的专属行程方案'}
              </p>
            </div>
          </div>
          <div className="flex flex-wrap gap-2 mt-4">
            <Badge variant="secondary" className="bg-bg-secondary text-primary rounded-full">
              <Calendar className="w-3 h-3 mr-1" />
              {result.days}天
            </Badge>
            <Badge variant="secondary" className="bg-bg-secondary text-primary rounded-full">
              <MapPin className="w-3 h-3 mr-1" />
              {result.destination || '行程规划'}
            </Badge>
          </div>
        </CardHeader>
      </Card>

      {result.dailyPlan?.map((day) => (
        <DayTimeline key={day.day} day={day} dayNumber={day.day} />
      ))}
    </div>
  );
};
